import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

interface IProductRebillingConfig {
  enabled: boolean;
  markup: number;
  basePrice: number;
  optIn: boolean;
}
interface IProductRebillingUpdatePayload {
  product: string;
  config: IProductRebillingConfig;
}

const ProductRebillingService = {
  getByProduct: async (
    entityId: string,
    entityType: string,
    product: string
  ) => {
    return requests(SERVICE_NAME.REVEX_SAAS_BILLING_API).get(
      `support/billing-config/${entityType}/${entityId}/${product}`
    );
  },

  updateConfig: async (
    companyId: string,
    productRebilling: IProductRebillingUpdatePayload
  ) => {
    let url = `support/billing-config/${companyId}?newLocationOptIn=true`;
    const updateData = {
      entityType: "COMPANY",
      product: productRebilling.product,
      config: productRebilling.config,
    };
    return requests(SERVICE_NAME.REVEX_SAAS_BILLING_API).put(url, updateData);
  },
};

export default ProductRebillingService;
